import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import CountdownTimer from '../../../components/feature/CountdownTimer';

export default function InsuranceProfessionalizationSection() {
  const { ref, isVisible } = useScrollAnimation();

  const handleCTAClick = () => {
    window.REACT_APP_NAVIGATE('/profissionalizacao-contratacao-seguros');
  };

  return (
    <section className="py-20 bg-[#0F3D3E] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ref}
          className={`transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Badge */}
          <div className="flex justify-center mb-6">
            <span className="inline-block px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-sm font-medium tracking-wide">
              PROFISSIONALIZAÇÃO DA CONTRATAÇÃO
            </span>
          </div>

          {/* Título */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-center mb-6 leading-tight">
            Você ainda está negociando seu seguro como se fosse só preço?
          </h2>

          {/* Subtítulo */}
          <p className="text-lg sm:text-xl text-white/90 text-center max-w-4xl mx-auto mb-12 leading-relaxed">
            O mercado ficou técnico e contratual. Negociar sozinho pode significar pagar mais e estar protegido menos.
          </p>

          {/* Bloco de destaque */}
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 sm:p-8 mb-16 max-w-5xl mx-auto">
            <p className="text-base sm:text-lg text-white/95 leading-relaxed text-center">
              "Em análises comparativas internas da IBX Brasil, casos de contratação sem assessoria técnica podem apresentar diferenças relevantes de custo/eficiência — em alguns cenários, chegando a <strong className="text-[#F57C00] font-bold">até 43%</strong>."
            </p>
          </div>

          {/* Comparação visual */}
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {/* Negociando sozinho */}
            <div className="bg-white/5 backdrop-blur-sm border border-red-500/30 rounded-2xl p-6 sm:p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-red-500/20 rounded-full flex items-center justify-center">
                  <i className="ri-close-circle-line text-2xl text-red-400"></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold">Negociando sozinho</h3>
              </div>
              <ul className="space-y-4">
                {[
                  'Foco apenas no preço',
                  'Pouca leitura de cláusulas críticas',
                  'Coberturas desalinhadas ao risco real',
                  'Negociação limitada',
                  'Risco de descobrir falhas no sinistro'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <i className="ri-close-line text-xl text-red-400 mt-1 flex-shrink-0"></i>
                    <span className="text-white/90">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Com assessoria IBX */}
            <div className="bg-white/5 backdrop-blur-sm border border-[#1F7A4C]/30 rounded-2xl p-6 sm:p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-[#1F7A4C]/20 rounded-full flex items-center justify-center">
                  <i className="ri-checkbox-circle-line text-2xl text-[#1F7A4C]"></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold">Com assessoria IBX</h3>
              </div>
              <ul className="space-y-4">
                {[
                  'Diagnóstico técnico do risco',
                  'Revisão completa da apólice/cláusulas',
                  'Estruturação correta de coberturas',
                  'Negociação estratégica',
                  'Otimização de custo com segurança contratual'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <i className="ri-check-line text-xl text-[#1F7A4C] mt-1 flex-shrink-0"></i>
                    <span className="text-white/90">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Aplicação */}
          <div className="text-center mb-10">
            <p className="text-base sm:text-lg text-white/80">
              <strong className="text-white font-semibold">Aplicável a:</strong> Auto, Incêndio Empresarial, Vida Empresarial, Frota e Contratos Corporativos.
            </p>
          </div>

          {/* Contador Regressivo */}
          <CountdownTimer location="profissionalizacao" />

          {/* CTA */}
          <div className="flex justify-center">
            <button
              onClick={handleCTAClick}
              className="inline-flex items-center gap-2 px-8 py-4 bg-[#F57C00] text-white font-semibold rounded-lg hover:bg-[#E56B00] transition-all duration-300 hover:scale-105 hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Profissionalizar minha contratação
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}